import type { HourReportDayAuditResponse } from "./schemas"

export type HourReportDayAuditViewModel = HourReportDayAuditResponse & {
  isReadyForCheck: boolean
  isReadyForApproval: boolean
  isApproved: boolean
  isReadyForCheckEnabled: boolean
  isReadyForApprovalEnabled: boolean
  isApprovedEnabled: boolean
}

const shouldEnableReadyForCheck = (dayAudit: HourReportDayAuditResponse): boolean => {
  if (dayAudit.canManageAsHourReportAdmin) return true
  if (dayAudit.status === "approved" || dayAudit.status === "checked") return false
  return dayAudit.canMarkReadyForCheck
}

const shouldEnableReadyForApproval = (dayAudit: HourReportDayAuditResponse): boolean => {
  if (dayAudit.canManageAsHourReportAdmin) return true
  if (dayAudit.status === "approved") return false
  return dayAudit.canMarkReadyForApproval
}

const shouldEnableApproved = (dayAudit: HourReportDayAuditResponse): boolean => {
  if (dayAudit.canManageAsHourReportAdmin) return true
  return dayAudit.canMarkApproved
}

const isReadyForCheck = (status: HourReportDayAuditResponse["status"]) => {
  return status === "submitted" || status === "checked" || status === "approved"
}

const isReadyForApproval = (status: HourReportDayAuditResponse["status"]) => {
  return status === "checked" || status === "approved"
}

const isApproved = (status: HourReportDayAuditResponse["status"]) => {
  return status === "approved"
}

export const makeHourReportDayAuditViewModel = (
  auditResponse: HourReportDayAuditResponse
): HourReportDayAuditViewModel => {
  const isReadyForCheckEnabled = shouldEnableReadyForCheck(auditResponse)
  const isReadyForApprovalEnabled = shouldEnableReadyForApproval(auditResponse)
  const isApprovedEnabled = shouldEnableApproved(auditResponse)

  return {
    ...auditResponse,
    isReadyForCheck: isReadyForCheck(auditResponse.status),
    isReadyForApproval: isReadyForApproval(auditResponse.status),
    isApproved: isApproved(auditResponse.status),
    isReadyForCheckEnabled,
    isReadyForApprovalEnabled,
    isApprovedEnabled,
  }
}
